import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  itemValue = new BehaviorSubject(this.configItem);

  set configItem(value: string) {
    localStorage.setItem('config', value);
    this.itemValue.next(value);
  }

  get configItem() {
    return localStorage.getItem('config') || '';
  }

  watchExternalChanges() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'config') {
        this.itemValue.next(event.newValue || '');
      }
    });
  }
}
